import { render, staticRenderFns } from "./phoneLogin.vue?vue&type=template&id=5a2a1b49&scoped=true&"
import script from "./phoneLogin.vue?vue&type=script&lang=ts&"
export * from "./phoneLogin.vue?vue&type=script&lang=ts&"
import style0 from "./phoneLogin.vue?vue&type=style&index=0&id=5a2a1b49&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2a1b49",
  null
  
)

export default component.exports